module.exports = __webpack_public_path__ + "img/0a91f8f.svg";